import {Injectable} from '@angular/core';
import {forkJoin, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {VehicleTransaction} from '../../models/vte';
import {OperationsOrganizationService} from './operations-organization.service';
import {VteApiService} from './vte-api.service';

export type OperationsMetrics = {
    completed: number;
    waiting: number;
    needsAttention: number;
    failed: number;
    latestTransaction: VehicleTransaction | null;
};

@Injectable({
    providedIn: 'root',
})
export class OperationsMetricsService {
    constructor(
        private vteApi: VteApiService,
        private organizationService: OperationsOrganizationService,
    ) {
    }

    loadMetrics(orgId?: string | null): Observable<OperationsMetrics> {
        const resolvedOrgId = this.organizationService.resolveOrganizationId(orgId);
        const baseParams = {
            page: 1,
            page_size: 1,
            ...(resolvedOrgId != null ? {org_id: resolvedOrgId} : {}),
        };

        return forkJoin({
            completed: this.countTransactions({...baseParams, status_group: 'completed'}),
            waiting: this.countTransactions({...baseParams, status_group: 'waiting'}),
            needsAttention: this.countTransactions({...baseParams, status_group: 'needs_attention'}),
            failed: this.countTransactions({...baseParams, status_group: 'failed'}),
            latestTransaction: this.vteApi.listVehicleTransactions({
                ...baseParams,
                ordering: '-anchor_timestamp',
            }).pipe(
                map((response) => response.results?.[0] || null),
                catchError(() => of(null)),
            ),
        });
    }

    private countTransactions(params: Record<string, unknown>): Observable<number> {
        return this.vteApi.listVehicleTransactions(params).pipe(
            map((response) => response.count || 0),
            catchError(() => of(0)),
        );
    }
}
